import { NotificationsQueryV1, NotificationsResponseV1 } from "@strust/contracts";
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../shared/api/api-provider.tsx";
import { defineEndpoint } from "../../../shared/api/endpoint.ts";

export const listNotificationsEndpoint = defineEndpoint({
  method: "GET",
  path: "/me/notifications",
  query: NotificationsQueryV1,
  response: NotificationsResponseV1,
});

const POLL_MS = 60_000;

/** In-app notifications of the console user (export ready or failed), refreshed every minute. */
export function useNotifications() {
  const client = useApiClient();
  return useQuery({
    queryKey: ["me", "notifications"],
    refetchInterval: POLL_MS,
    queryFn: ({ signal }) => client.call(listNotificationsEndpoint, { query: {}, signal }),
  });
}
